import Vue from 'vue';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import VeeElement from 'vee-element';
// import VeeElement from 'vee-element/dist/vee-element.js'
import VueProgressiveImage from 'vue-progressive-image';

// Pinia must be imported BEFORE router/middleware to be available during bootstrap
import pinia from './pinia';

import validator from './validator';
import locale from './lang/de';
import router from './router';
import i18n from './i18n';
import App from './App';

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);

import './video';
import './quill';

// import 'element-ui/lib/theme-chalk/index.css'

import apolloProvider from './store/apollo';

import '@/helpers/util';
import '@/middleware'; // permission control

// Multistore: every component can ask whether the current screen shows shared
// parent-shop data that this caller may not write, so write controls can be
// hidden instead of failing on save. Driven by the `sharedWithShop` route meta
// and the API-resolved `shop.can_manage_shared_data` flag.
import _ from 'lodash';
import { useSetupStore } from '@/stores';
Vue.mixin({
    computed: {
        sharedShopDataReadOnly() {
            if (!_.get(this.$route, 'meta.sharedWithShop')) return false;
            return _.get(useSetupStore().activeCms, 'shop.can_manage_shared_data') === false;
        },
    },
});

//Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, far } from '@awesome.me/kit-7532cad887/icons/modules/'
library.add(fas, far)

import { fas as solid } from '@fortawesome/free-solid-svg-icons'
import { far as regular } from '@fortawesome/free-regular-svg-icons'
library.add(solid, regular)

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueProgressiveImage, {
    // blur: 0,
    // delay: 100000 // 2 seconds before the image is displayed
});

Vue.use(ElementUI, { locale, size: 'medium' });
Vue.use(VeeElement, validator, true);

// Fix vee-element bug: fields without rules call the validate callback
// but don't return, so they fall through to validator.verify() which calls
// the callback a second time. This double-counts rule-less fields, causing
// el-form.validate() to resolve before async validators (like unique checks)
// have finished — allowing form submission despite validation errors.
var originalFormItemValidate = Vue.options.components.ElFormItem.options.methods.validate;
Vue.options.components.ElFormItem.options.methods.validate = function (trigger, callback) {
    if (callback === undefined) {
        callback = function () {};
    }
    var rules = this.getRules();
    if (!rules) {
        callback();
        return;
    }
    return originalFormItemValidate.call(this, trigger, callback);
};

// A click on the backdrop must never discard a half-filled form. Element's
// default is to close on it, and a drag that starts inside the dialog (picking
// a time, selecting text) but releases over the backdrop fires that same click.
// Both dialogs and drawers here are forms, so the default is flipped globally;
// a dialog that genuinely wants it back sets :close-on-click-modal="true"
// (drawers: :wrapper-closable="true"). Escape still closes.
Vue.options.components.ElDialog.options.props.closeOnClickModal.default = false;
Vue.options.components.ElDrawer.options.props.wrapperClosable.default = false;

import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);

import Affix from 'vue-affix';
Vue.use(Affix);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import VueDragscroll from "vue-dragscroll";
Vue.use(VueDragscroll);

Vue.directive('focus', {
    inserted: el => {
        if (el.tagName === 'DIV') {
            const input = el.getElementsByTagName('input');
            if (input.length) input[0].focus();
        } else {
            el.focus();
        }
    }
});

import noAutofill from '@/directives/noAutofill';
Vue.directive('noautofill', noAutofill);

import focusTrap from '@/directives/focusTrap';
Vue.directive('focus-trap', focusTrap);

new Vue({
    router,
    i18n,
    pinia,
    // provide: apolloProvider.provide(),
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
